import {faReceipt} from "@fortawesome/free-solid-svg-icons";
import {CompanyReportModel} from '../../redux/companyMonitorTypes';
import CompanyReportInfoCard from './CompanyReportInfoCard';

interface Props {
  report: CompanyReportModel
}

const CompanyReportTaxInfoCard = ({report}: Props) => {

  const renderRegistration = (label: string, registered: boolean | null) => {
    if (registered === null || registered === undefined) {
      return <p>{label}: <span>Unknown</span></p>
    }

    return <p>{label}: <span>{registered ? 'Yes' : 'No'}</span></p>
  }

  return (
    <CompanyReportInfoCard title='Tax information' icon={faReceipt} sources={['CreditSafe']}>
      {renderRegistration('Registered for F-tax', report.registeredForFTax)}
      {renderRegistration('Registered for VAT', report.registeredForVat)}
      {renderRegistration('Registered for employee tax', report.registeredForEmployeeTax)}
    </CompanyReportInfoCard>
  )
}
export default CompanyReportTaxInfoCard
